// Zentrale Kontaktdaten für konsistente Verwendung
export const PHONE_NUMBER = "+4915129722904";
export const PHONE_DISPLAY = "+49\u00A01512\u00A09722904";
export const PHONE_WHATSAPP = "4915129722904";

export const EMAIL = "info@frostflotte.de";

// Marketing-/Anzeigename (wird auf der Seite angezeigt)
export const ADDRESS = {
  company: "Frostflotte",
  street: "Rödelheimer Landstr. 96",
  city: "60487 Frankfurt am Main",
  region: "Hessen",
  country: "DE",
};

// Abholadresse für Fahrzeuge
export const PICKUP_ADDRESS = {
  street: "Rödelheimer Landstr. 96",
  city: "60487 Frankfurt am Main",
  region: "Hessen",
  country: "DE",
};

// Rechtliche Firmendaten (für Impressum)
export const LEGAL_COMPANY = {
  name: "Sandhu World Trade GmbH",
  street: "Ziegelhüttenweg 22",
  city: "60598 Frankfurt am Main",
  region: "Hessen",
  country: "DE",
  register: "HRB 108683",
  registerCourt: "Amtsgericht Frankfurt am Main",
  managingDirectors: [
    "Sandeep Singh Sandhu",
    "Simardeep Singh Sandhu",
  ],
  capital: "25.000,00 EUR",
  vatId: "DE411981516",
};

export const WEBSITE_URL = "https://frostflotte.de";
